module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "ser_1",
      "role": "doc-chapter"
    }
  }, [_c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The Collected Works of F. A. Hayek")]), _vm._v(" "), _c('p', {
    staticClass: "serf",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Founding Editor: W. W. Bartley III")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("General Editor: Bruce Caldwell")]), _vm._v(" "), _c('p', {
    staticClass: "serpf",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Published with the support of")])]), _vm._v(" "), _c('p', {
    staticClass: "serf",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Hoover Institution on War, Revolution and PeaceStanford University")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Cato Institute")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Earhart Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Pierre F. and Enid Goodrich Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Heritage Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Morris Foundation, Little Rock")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-114c1fc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-hayek-vol19-0006.vue
// module id = 69
// module chunks = 0